module.exports = __webpack_public_path__ + "img/none-module.8d400e3b.svg";